import React from "react"
import styled from "@emotion/styled"
import { Link } from "gatsby"
import { Container, Flex, Box } from "theme-ui"
import { useBreakpointIndex } from "@theme-ui/match-media"

const Wrapper = styled.div`
    position: relative;
    text-align: center;
    background: #eae8eb;
    margin-bottom: 3rem;
    padding: 2rem;
    text-align: left;
    & h2 {
        margin-bottom: 0;
    }
    & p {
        margin: 0 2rem;
        color: ${(props) => props.theme.colors.text1};
        background-color: transparent !important;
        & span {
            background-color: transparent !important;
        }
    }
    & .image-round {
        border-radius: 1rem;
        width: 250px;
    }
    & .show-md {
        display: block;
    }
    & .show-s {
        display: none;
    }

    @media (max-width: ${(props) => props.theme.breakpoints[6]}) {
        & h2 {
            margin-top: 1rem;
        }
    }
    @media (max-width: ${(props) => props.theme.breakpoints[4]}) {
        & h2 {
            margin-top: 0rem;
        }
    }
    @media (max-width: ${(props) => props.theme.breakpoints[3]}) {
        & .show-md {
            display: none;
        }
        & .show-s {
            display: block;
        }
        & .image-round {
            width: 150px;
        }
    }
`

const ReadMore = styled(Link)`
    background: ${(props) => props.theme.colors.light_blue_1};
    border-radius: 2rem;
    margin-left: 2rem;
    padding: 0.7rem 1.3rem;
    color: #ffffff !important;
    text-decoration: none;
    font-family: Museo Slab;
    font-weight: 700;

    &:hover {
        text-decoration: none !important;
    }
`

function PathWays({ description }) {
    const breakpoints = useBreakpointIndex()
    return (
        <Wrapper>
            <Container>
                <Flex sx={{ justifyContent: "center" }}>
                    <h2>Academic Pathways</h2>
                </Flex>
                <Flex
                    sx={{
                        justifyContent: "center",
                        margin: "auto",
                        flexDirection: breakpoints > 4 ? "row" : "column",
                    }}
                >
                    <Box
                        sx={{
                            flex: "0 0 20%",
                            textAlign: "center",
                            marginTop: breakpoints <= 4 ? "1rem" : "0",
                        }}
                    >
                        <img
                            className="image-round"
                            src="/homepage/img-home-academic-pathway.jpg"
                            alt=""
                        />
                    </Box>
                    <Box>
                        <div
                            style={{ marginBottom: "2rem" }}
                            dangerouslySetInnerHTML={{ __html: description }}
                        />
                        <ReadMore to="/our-programs/academic-pathway">
                            Read More
                        </ReadMore>
                    </Box>
                    <Box sx={{ flex: "0 0 23%", textAlign: "center" }}>
                        <img
                            src="/homepage/img-home-volunteer-with-dynamics-eip.png"
                            alt=""
                            style={{ marginLeft: "auto" }}
                        />
                    </Box>
                </Flex>
            </Container>
        </Wrapper>
    )
}

export default PathWays
